export const enum BroadcastSessionAction {
  Logout,
  SessionChange,
  None,
}

/**
 * Decides what a tab must do about a peer's `auth.session_refreshed` broadcast.
 *
 * `currentUserId` has to come from the session snapshot rather than the profile: the
 * profile slice is filled asynchronously and can be empty on a page that is perfectly
 * signed in, and reading `null` there turns an ordinary token rotation into an apparent
 * account switch — a full reload for nothing.
 *
 * - `Logout` — the peer signalled auth loss (`auth: null`) and this tab is signed in.
 *   Reload; it clears cookies.
 * - `SessionChange` — a different subject is signed in now, including the case of an
 *   anonymous tab learning that a peer logged in. The page must reload to adopt it.
 * - `None` — same subject: a plain rotation, which the manager's own broadcast handler
 *   absorbs by applying the newer token in place. Also auth loss in an anonymous tab:
 *   it has nothing to lose, and a reload would wipe what it is doing, a login form for one.
 */
export const decideBroadcastSessionAction = (auth: { user_id: string } | null, currentUserId: string | null): BroadcastSessionAction => {
  if (auth === null) return currentUserId === null ? BroadcastSessionAction.None : BroadcastSessionAction.Logout
  if (auth.user_id !== currentUserId) return BroadcastSessionAction.SessionChange
  return BroadcastSessionAction.None
}
